import { Navigate, Route, Routes } from "react-router-dom";

import { id } from "date-fns/locale";
import "moment/locale/id";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./App.css";

import Activity from "./pages/Activity";

import CompanyGroup from "./pages/CompanyGroup";
import CompanyGroupCreate from "./pages/CompanyGroupCreate";
import CompanyGroupUpdate from "./pages/CompanyGroupUpdate";

import Completeness from "./pages/Analytic/completeness/Emission";

import Dashboard from "./pages/Dashboard";

import Emission from "./pages/Scope1&2/Emission";
import EmissionCreate from "./pages/Scope1&2/EmissionCreate";
import EmissionUpdate from "./pages/Scope1&2/EmissionUpdate";

import EmissionCreateInBulk from "./pages/Scope1&2/EmissionCreateInBulk";

import Office from "./pages/Office";
import OfficeCreate from "./pages/OfficeCreate";
import OfficeUpdate from "./pages/OfficeUpdate";

import Onboard from "./pages/Onboard";

import Program from "./pages/Program";

import Revenue from "./pages/Revenue";
import RevenueCreate from "./pages/RevenueCreate";
import RevenueUpdate from "./pages/RevenueUpdate";
import SettingRevenueAndProductionForm from "./pages/SettingRevenueAndProductionForm";
import SettingRevenueAndProductionList from "./pages/SettingRevenueAndProductionList";

import Setting from "./pages/Setting";
import Setting2 from "./pages/Setting-2";

import ReportGHG from "./pages/ReportGHGInventory";
// import ReportGRI from "./pages/ReportGRI"; // GRI Report hidden
import ReportISO from "./pages/ReportISO";
import ReportSummary from "./pages/ReportSummary";

import SBTi from "./pages/Analytic/SBTi";

import Removal from "./pages/Removal";
import RemovalCreate from "./pages/RemovalCreate";
import RemovalUpdate from "./pages/RemovalUpdate";

import Reduction from "./pages/Action/Reduction";
import ReductionCreate from "./pages/Action/ReductionCreate";
import ReductionUpdate from "./pages/Action/ReductionUpdate";

import Supplychain from "./pages/Supplychain";
import SupplychainCreate from "./pages/SupplychainCreate";
import SupplychainUpdate from "./pages/SupplychainUpdate";

import Scenario from './pages/Analytic/Scenario';
import SettingCarbonIntensity from './pages/Setting/SettingCarbonIntensity';
import SettingScenario from './pages/Setting/SettingScenario';

import ClientEsgMatrices from './pages/EsgMatrices';

import AnalyticsCarbonIntensity from "./pages/Analytic/CarbonIntensity";
import AnalyticsCompany from "./pages/Analytic/Company";
import AnalyticsLocation from "./pages/Analytic/Location";
import AnalyticsLocationSummary from "./pages/Analytic/LocationSummary";

import Profile from "./pages/Profile";

import Scope3Category1And2Create from "./pages/Scope3/Category1And2SpendBased/Create";
import Scope3Category1And2 from "./pages/Scope3/Category1And2SpendBased/Dashboard";
import Scope3Category1And2Update from "./pages/Scope3/Category1And2SpendBased/Update";

import Scope3Category3 from "./pages/Scope3/Category3/Dashboard";

import Scope3Category4And9Create from "./pages/Scope3/Category4And9/Create";
import Scope3Category4And9 from "./pages/Scope3/Category4And9/Dashboard";
import Scope3Category4And9Update from "./pages/Scope3/Category4And9/Update";

import Scope3Category5Create from "./pages/Scope3/Category5/Create";
import Scope3Category5 from "./pages/Scope3/Category5/Dashboard";
import Scope3Category5Update from "./pages/Scope3/Category5/Update";

import Scope3Category6Create from "./pages/Scope3/Category6/Create";
import Scope3Category6 from "./pages/Scope3/Category6/Dashboard";
import Scope3Category6Update from "./pages/Scope3/Category6/Update";

import Scope3Category7Create from "./pages/Scope3/Category7/Create";
import Scope3Category7 from "./pages/Scope3/Category7/Dashboard";
import Scope3Category7Update from "./pages/Scope3/Category7/Update";

import Scope3Category11Create from "./pages/Scope3/Category11/Create";
import Scope3Category11 from "./pages/Scope3/Category11/Dashboard";
import Scope3Category11Update from "./pages/Scope3/Category11/Update";

import POCEmissionSearch from "./pages/POCEmissionSearch";

import HeaderSection from "./components/HeaderSection";
import LockedContent from "./components/LockedContent";
import MenuSection from "./components/MenuSection";

import EmissionFactorUpdates from "./pages/EmissionFactorUpdates";
import EmissionSources from "./pages/EmissionSources";
import SettingChangePassword from "./pages/Setting/ChangePassword";
import SettingByOnboarding from "./pages/Setting/SettingByOnboarding";
import SettingUserRoles from "./pages/Setting/SettingUserRoles";
import SettingSubsidiaries from "./pages/Setting/Subsidiaries/SettingSubsidiaries";

import { WhatsApp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import GeneralInfoBox from "./components/GeneralInfoBox";
import useRouteHelpFab from "./hooks/useRouteBasedHelpFab";
import { ROUTE_PATHS } from "./library/helper";
import RevenueV2 from "./pages/RevenueV2";
import Scope3TestPage from "./pages/Scope3/Scope3TestPage";


import { Box, Typography, Link, Divider } from "@mui/material";

registerLocale("id", id);

export default function App() {
    const { t } = useTranslation();
    useRouteHelpFab();

    const FooterSection = () => (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">
                        &copy;&nbsp;{new Date().getFullYear()} TruCarbon
                    </div>
                    <div className="col-sm-6">
                        <div className="text-sm-end d-none d-sm-block" />
                    </div>
                </div>
            </div>
        </footer>
    );

    const Layout = ({ children, showMenuSection = false, fullHeight = true }) => (
        <div id="layout-wrapper" className={fullHeight ? "flex flex-col min-h-screen" : undefined}>
            <HeaderSection isOnboarding={showMenuSection} />
            {!showMenuSection && <MenuSection />}
            <LockedContent
                title="locked.content.title.1"
                body="locked.content.body.1">
                <div className={fullHeight ? "flex-1 main-content" : "main-content"}>{children}</div>
            </LockedContent>
            <FooterSection />
        </div>
    );

    return (
        <Routes>
            <Route
                path={"/scope3-test-page"}
                element={
                    <Layout>
                        <Scope3TestPage />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.onboard}
                element={
                    <Layout showMenuSection>
                        <Onboard />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.dashboard}
                element={
                    <Layout>
                        <Dashboard />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.analyticsLocationSummary}
                element={
                    <Layout>
                        <LockedContent>
                            <AnalyticsLocationSummary />
                        </LockedContent>
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.analyticsLocation}
                element={
                    <Layout>
                        <LockedContent>
                            <AnalyticsLocation />
                        </LockedContent>
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.analyticsCompany}
                element={
                    <Layout>
                        <AnalyticsCompany />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.analyticsCarbonIntensity}
                element={
                    <Layout>
                        <LockedContent>
                            <AnalyticsCarbonIntensity />
                        </LockedContent>
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.analyticsCompletion}
                element={
                    <Layout>
                        <Completeness />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.analyticsSBTi}
                element={
                    <Layout>
                        <LockedContent>
                            <SBTi />
                        </LockedContent>
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.reductionCreate}
                element={
                    <Layout>
                        <ReductionCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.reductionUpdateById}
                element={
                    <Layout>
                        <ReductionUpdate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.reduction}
                element={
                    <Layout>
                        <LockedContent>
                            <Reduction />
                        </LockedContent>
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scenario}
                element={
                    <Layout>
                        <LockedContent>
                            <Scenario />
                        </LockedContent>
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.esgmatrices}
                element={
                    <Layout>
                        <ClientEsgMatrices />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingScenario}
                element={
                    <Layout>
                        <SettingScenario />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingSubsidiaries}
                element={
                    <Layout>
                        <SettingSubsidiaries />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingOrganizationInformation}
                element={
                    <Layout>
                        <SettingByOnboarding defaultState={0} />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingUsers}
                element={
                    <Layout>
                        <SettingByOnboarding defaultState={1} />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingUserRoles}
                element={
                    <Layout>
                        <SettingUserRoles />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingCarbonIntensity}
                element={
                    <Layout>
                        <SettingCarbonIntensity />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.setting}
                element={
                    <Layout>
                        <Setting />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingChangePassword}
                element={
                    <Layout>
                        <SettingChangePassword />
                    </Layout>
                }
            />
            <Route
                path={"/setting-2"}
                element={
                    <Layout>
                        <Setting2 />
                    </Layout>
                }
            />
            <Route
                path={"/setting/advanced/emission-sources"}
                element={
                    <Layout>
                        <EmissionSources />
                    </Layout>
                }
            />
            <Route
                path={"/emission-factor-updates"}
                element={
                    <Layout>
                        <EmissionFactorUpdates />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.EmissionFactorUpdates}
                element={
                    <Layout>
                        <EmissionFactorUpdates />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category1}
                element={
                    <Layout>
                        <Scope3Category1And2 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category1Create}
                element={
                    <Layout>
                        <Scope3Category1And2Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category1Update}
                element={
                    <Layout>
                        <Scope3Category1And2Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category2}
                element={
                    <Layout>
                        <Scope3Category1And2 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category2Create}
                element={
                    <Layout>
                        <Scope3Category1And2Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category2Update}
                element={
                    <Layout>
                        <Scope3Category1And2Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category3}
                element={
                    <Layout>
                        <Scope3Category3 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category4}
                element={
                    <Layout>
                        <Scope3Category4And9 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category4Create}
                element={
                    <Layout>
                        <Scope3Category4And9Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category4Update}
                element={
                    <Layout>
                        <Scope3Category4And9Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category5}
                element={
                    <Layout>
                        <Scope3Category5 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category5Create}
                element={
                    <Layout>
                        <Scope3Category5Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category5Update}
                element={
                    <Layout>
                        <Scope3Category5Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category6}
                element={
                    <Layout>
                        <Scope3Category6 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category6Create}
                element={
                    <Layout>
                        <Scope3Category6Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category6Update}
                element={
                    <Layout>
                        <Scope3Category6Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category7}
                element={
                    <Layout>
                        <Scope3Category7 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category7Create}
                element={
                    <Layout>
                        <Scope3Category7Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category7Update}
                element={
                    <Layout>
                        <Scope3Category7Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category8}
                element={
                    <Layout>
                        <Dashboard />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category9}
                element={
                    <Layout>
                        <Scope3Category4And9 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category9Create}
                element={
                    <Layout>
                        <Scope3Category4And9Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category9Update}
                element={
                    <Layout>
                        <Scope3Category4And9Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category10}
                element={
                    <Layout>
                        <Dashboard />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category11}
                element={
                    <Layout>
                        <Scope3Category11 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category11Create}
                element={
                    <Layout>
                        <Scope3Category11Create />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category11Update}
                element={
                    <Layout>
                        <Scope3Category11Update />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category12}
                element={
                    <Layout>
                        <Dashboard />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category13}
                element={
                    <Layout>
                        <Dashboard />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category14}
                element={
                    <Layout>
                        <Dashboard />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category15}
                element={
                    <Layout>
                        <Supplychain />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category15Create}
                element={
                    <Layout>
                        <SupplychainCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.scope3category15Update}
                element={
                    <Layout>
                        <SupplychainUpdate />
                    </Layout>
                }
            />

            {/* Removal */}
            <Route
                path={ROUTE_PATHS.removalUpdateById}
                element={
                    <Layout>
                        <RemovalUpdate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.removalCreate}
                element={
                    <Layout>
                        <RemovalCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.removal}
                element={
                    <Layout>
                        <LockedContent>
                            <Removal />
                        </LockedContent>
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.reportIso}
                element={
                    <Layout>
                        <ReportISO />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.reportGhg}
                element={
                    <Layout>
                        <ReportGHG />
                    </Layout>
                }
            />
            {/* GRI Report route hidden */}
            {/* <Route
                path={ROUTE_PATHS.reportGri}
                element={
                    <Layout>
                        <ReportGRI />
                    </Layout>
                }
            /> */}
            <Route
                path={ROUTE_PATHS.reportSummary}
                element={
                    <Layout>
                        <ReportSummary />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.activity}
                element={
                    <Layout>
                        <Activity />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.divisionUpdateById}
                element={
                    <Layout>
                        <CompanyGroupUpdate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.divisionCreate}
                element={
                    <Layout>
                        <CompanyGroupCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.division}
                element={
                    <Layout>
                        <CompanyGroup />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.revenueUpdateById}
                element={
                    <Layout>
                        <RevenueUpdate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.revenueCreate}
                element={
                    <Layout>
                        <RevenueCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.revenue}
                element={
                    <Layout>
                        <Revenue />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.unitRevenue}
                element={
                    <Layout>
                        <RevenueV2 />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingRevenueUpdateById}
                element={
                    <Layout>
                        <SettingRevenueAndProductionForm />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingRevenueCreate}
                element={
                    <Layout>
                        <SettingRevenueAndProductionForm />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.settingRevenue}
                element={
                    <Layout>
                        <SettingRevenueAndProductionList />
                    </Layout>
                }
            />
            {/* <Route
                path={ROUTE_PATHS.userUpdateById}
                element={
                    <Layout>
                        <UserUpdate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.userCreate}
                element={
                    <Layout>
                        <UserCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.user}
                element={
                    <Layout>
                        <User />
                    </Layout>
                }
            /> */}
            <Route
                path={ROUTE_PATHS.locationUpdateById}
                element={
                    <Layout>
                        <OfficeUpdate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.locationCreate}
                element={
                    <Layout>
                        <OfficeCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.location}
                element={
                    <Layout>
                        <Office />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.emissionUpdateById}
                element={
                    <Layout>
                        <EmissionUpdate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.emissionCreate}
                element={
                    <Layout>
                        <EmissionCreate />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.emissionCreateInBulk}
                element={
                    <Layout>
                        <EmissionCreateInBulk />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.emission}
                element={
                    <Layout>
                        <Emission />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.program}
                element={
                    <Layout>
                        <Program />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.profile}
                element={
                    <Layout>
                        <Profile />
                    </Layout>
                }
            />
            <Route
                path={"/poc-emission-search"}
                element={
                    <Layout>
                        <POCEmissionSearch />
                    </Layout>
                }
            />
            <Route
                path={ROUTE_PATHS.waitingApproval}
                element={
                    <div id="layout-wrapper" className="flex flex-col min-h-screen">
                        <HeaderSection isOnboarding />
                        <div className="vertical-overlay"></div>

                        <div style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                        }}>
                            <GeneralInfoBox
                                title="locked.content.title.3"
                                body="locked.content.body.3"
                                showClose={false}
                                footer={
                                    <a
                                        href="https://wa.me/6282228886906?text=Hi%20Trucarbon,%20can%20my%20account%20get%20approved?"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-success d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold shadow-sm"
                                        style={{ borderRadius: 12 }}
                                    >
                                        <WhatsApp />
                                        {t("Whatsapp Support")}
                                    </a>
                                }
                            >
                                <Divider sx={{ borderColor: "black" }} />

                                <Box
                                    sx={{
                                        mt: 2,
                                        mx: "auto",
                                        maxWidth: 360,          // key: controls wrapping
                                        textAlign: "left",      // key: fixes the awkward centering wrap
                                        lineHeight: 1.5,
                                    }}
                                >
                                    <Typography variant="body2">
                                        To help our team verifying your account access, please fill in this form here:
                                        <Link
                                            href="https://tinyurl.com/TruCountFreeTrial"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                display: "block",
                                                mt: 0.5,
                                                fontWeight: 700,
                                                textAlign: "center",
                                                textDecoration: "underline !important",
                                            }}
                                        >
                                            tinyurl.com/TruCountFreeTrial
                                        </Link>
                                    </Typography>

                                    <Typography variant="caption" sx={{ display: "block", mt: 1, opacity: 0.7 }}>
                                        Already submitted? You can ignore this.
                                    </Typography>
                                </Box>
                            </GeneralInfoBox>

                        </div>

                        <FooterSection />
                    </div>
                }
            />

            <Route path="*" element={<Navigate to={ROUTE_PATHS.dashboard} />} />
        </Routes>
    );
}
